import { useQuery } from "react-query";
import { getDataStaffBonusColumns } from "~/pages/StaffBonus/GetDataStaffRequests/getDataStaffBonusColumns";

export default function useGetStaffBonusColumns() {
  return useQuery({
    queryKey: ["getDataStaffBonusColumns"],
    queryFn: () => getDataStaffBonusColumns(),
    refetchOnWindowFocus: false,
    // enabled,
    cacheTime: 0,
  });
}
